import TourPackageHttp from "../../tourPackageHttp";

class SpotServices {
  static async getAllSpots() {
    return TourPackageHttp.get("/spots");
  }
  static async getSpotsById(id) {
    return TourPackageHttp.get(`/spots/${id}`);
  }
  // static async getDriverTripcount(id){
  //     return Http.get(`/rider-trip-counts/${id}`);
  // }
  static async updateSpots(id, data) {
    console.log(
      "========================================data in the updatePlace",
      data
    );
    return TourPackageHttp.update(`/spots/${id}`, data);
  }
  static async addSpots(data) {
    return TourPackageHttp.post("/spots/create", data);
  }

  static async deleteSpot(id) {
    return TourPackageHttp.delete(`/spots/${id}`);
  }
}
export default SpotServices;
